﻿window.info_electricconnection_hist_edit = function () {
    var _id;
    var instance = {
        init: function () {      
            writePmaxSum();
            im_decimal.mask(".pmax");          

            var filedsCollection = document.getElementsByClassName("maskfield");
            for (var i = 0; i < filedsCollection.length; i++) {
                filedsCollection[i].onpaste = function (e) {
                    var valuetovalidate = e.clipboardData.getData('Text').replace(".", ",");
                    validate_pmax_input.validate(e, valuetovalidate, _id);              
                };
                filedsCollection[i].onkeypress = function (e) {
                    var valuetovalidate = e.target.value.replace(".", ",");
                    validate_pmax_input.validate(e, valuetovalidate, _id);             
                };
                filedsCollection[i].onkeydown = function (e) {
                    var valuetovalidate = e.target.value.replace(".", ",");
                    validate_pmax_input.validate(e, valuetovalidate, _id);        
                };
            }
            var pmaxFieldCollection = document.getElementsByClassName('pmax');
            for (var i = 0; i < pmaxFieldCollection.length; i++) {
                pmaxFieldCollection[i].onchange = function (e) {     
                    writePmaxSum();
                };                
            }
        },
        firstinit: function (id) {
            $("#" + id + "_requestnumber").on("input", function (e) {
                if ($(this).val() === '')
                    $('#info_electricconnection_hist_edit_pmaxstatus').attr('disabled', 'disabled');
                else
                    $('#info_electricconnection_hist_edit_pmaxstatus').removeAttr('disabled');
            });
            im_decimal.mask("#info_electricconnection_hist_edit_pmax, #info_electricconnection_hist_edit_pinst");
            _id = id;
        },
        onsubmit: function (event, formid) {

            if (getPmaxSum() === null) {
                if (!confirm('Для одной или нескольких ТП/ОТП не заполнено значение максимальной мощности. Отчеты АФСМ, АУП по Договору, РФМ по договору где участвует данное ЭУ строится не будут. Для снятия ограничения заведите заявку в службу технической поддержки чтобы утвердить значение максимальной мощности по ЭУ.')) {
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    event.preventDefault();
                    return false;
                }
            }

            if (getPmaxSum() != null && (gerCurrSum() != getPmaxSum())) {
                alert('Значение в поле «Максимальная мощность по ЭУ, МВт (ручной ввод)» не соответствует значению из поля «Максимальная мощность по ЭУ, МВт (авто-расчет)»')
                {
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    event.preventDefault();  
                    return false;
                }                           
            }

            document.getElementById(formid).dispatchEvent(new SubmitEvent('submit', {
                submitter: event.target,
                bubbles: true,
                cancelable: true
            }));

            return true;
        },
        postEventFromElementWithApiResponse: function (id) {
            ajaxUtils.postEventFromElementWithApiResponse($('#' + id)[0]);
        }


    };

    var im_decimal = Inputmask("decimal", {
        radixPoint: ',',
        inputtype: "text",
        digits: 5,
        allowMinus: true
    });

    return instance;

    function gerCurrSum() {
       
        var cursum = $("#info_electricconnection_hist_edit_pmax").val().replace(/,/g, ".");

        return parseFloat(cursum).toFixed(5);;
    }

    function writePmaxSum() {
        var sum = getPmaxSum();
        $("#info_electricconnection_hist_edit_pmaxauto").val(sum);
    }
    function getPmaxSum() {
        if ($("#info_electricconnection_hist_edit_pmaxsum").val() === '')
            return null;
        var total = parseFloat($("#info_electricconnection_hist_edit_pmaxsum").val().replace(/,/g, "."));
        var empty = false;
        $('.pmax').each(function () {
            if ($(this).val() === '') {
                empty = true;
                return;
            }
            if ($(this).closest('tr').find('select').val() === '2')
                return;
            total = total + parseFloat($(this).val().replace(/,/g, "."));
           
        });
        if (empty)
            return null;
        return parseFloat(total).toFixed(5);
    }
}();

window.write_pmax = function () {
    var instance = {
        write: function () {
            var sum = getPmaxSum();
            $("#info_electricconnection_hist_edit_pmaxauto").val(sum);
        }
    }
    return instance;
    
}();

window.validate_pmax_input = function () {

    var instance = {
        validate: function (e, value, _id) {
            var f = function (x) {
                return ((x.toString().indexOf(',')) > -1 ? (x.toString().split(',').pop().length) : (0));
            }

            if (f(value) > 5) {

                document.getElementById(_id + "_actbtn").disabled = true;
                e.target.classList.add("warning");

            }
            else {
                document.getElementById(_id + "_actbtn").disabled = false;
                e.target.classList.remove("warning");
            }
        },
        write: function () {
            //alert('test');
            var sum = getPmaxSum();
            $("#info_electricconnection_hist_edit_pmaxauto").val(sum);
        }
    }    
    return instance;
}();



